import type { ReactNodeCompat } from '@/types/react-compat';
import Logo from '../logo';

type AuthLayoutProps = {
  children: ReactNodeCompat;
};

export function AuthLayout({ children }: AuthLayoutProps) {
  return (
    <div
      className="relative flex min-h-svh items-center justify-center overflow-hidden"
      style={{
        background: `linear-gradient(135deg,
          hsl(227 89% 41%) 35%,
          hsl(193, 100%, 91%) 200%)`,
      }}
    >
      {/* Pattern overlay for visual depth */}
      <Logo />

      {/* Dark overlay for better text contrast */}
      <div
        aria-hidden
        className="absolute inset-0 bg-linear-to-t from-black/30 via-black/20 to-transparent"
      />

      <div className="relative z-10 flex w-full max-w-xl flex-col items-center gap-10 px-6 py-12 text-center">
        <span className="sr-only">Emovia</span>
        <Logo className="h-10 w-full bg-white" />

        {children}
      </div>
    </div>
  );
}

export default AuthLayout;
